export const impressionRule = {
  id: 'impression',
  name: 'Impression Tracking',
  description: 'adimpression event should fire exactly once per ad',

  check(session) {
    const impressionEvents = session.events.filter(e => e.type === 'adimpression');
    const errorEvents = session.events.filter(e => e.type === 'aderror');

    if (errorEvents.length > 0 && impressionEvents.length === 0) {
      return { status: 'na', message: 'Ad errored before impression could fire' };
    }

    if (impressionEvents.length === 0) {
      return { status: 'fail', message: 'adimpression never fired' };
    }

    if (impressionEvents.length > 1) {
      return { status: 'fail', message: `adimpression fired ${impressionEvents.length} times (expected 1)` };
    }

    return { status: 'pass', message: 'adimpression fired exactly once' };
  },
};
